module.exports = __webpack_public_path__ + "static/media/1.bb0394d5.JPG";